function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1b {\n        fill: none;\n      }\n\n      .cls-2b {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3b {\n        clip-path: url(#clip-path-2);\n      }\n\n      .cls-4b {\n        fill: #63abba;\n      }\n\n      .cls-5b {\n        clip-path: url(#clip-path-3);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1b",
  width: 26.13,
  height: 34.985
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Clip_2",
  "data-name": "Clip 2",
  className: "cls-1b",
  d: "M0,0H5.517V5.429H0Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3"
}, /*#__PURE__*/React.createElement("path", {
  id: "Clip_5",
  "data-name": "Clip 5",
  className: "cls-1b",
  d: "M0,0H20.413V20.087H0Z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ic_journee_inactivite",
  className: "cls-2b"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_journee_inactivite-2",
  "data-name": "ic_journee_inactivite"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3",
  "data-name": "Group 3",
  transform: "translate(20.613 29.556)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Clip_2-2",
  "data-name": "Clip 2",
  className: "cls-1b",
  d: "M0,0H5.517V5.429H0Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3-2",
  "data-name": "Group 3",
  className: "cls-3b",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill_1",
  "data-name": "Fill 1",
  className: "cls-4b",
  d: "M2.759,0A2.8,2.8,0,0,0,.808.795a2.683,2.683,0,0,0,0,3.838,2.786,2.786,0,0,0,3.9,0,2.683,2.683,0,0,0,0-3.838A2.8,2.8,0,0,0,2.759,0"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_6",
  "data-name": "Group 6",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Clip_5-2",
  "data-name": "Clip 5",
  className: "cls-1b",
  d: "M0,0H20.413V20.087H0Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_6-2",
  "data-name": "Group 6",
  className: "cls-5b"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill_4",
  "data-name": "Fill 4",
  className: "cls-4b",
  d: "M11,5.43.808,15.453a2.684,2.684,0,0,0-.6,2.958,2.759,2.759,0,0,0,2.549,1.676h14.9a2.715,2.715,0,1,0,0-5.429H9.419L19.606,4.635a2.683,2.683,0,0,0,.6-2.958A2.759,2.759,0,0,0,17.655,0H2.759A2.737,2.737,0,0,0,0,2.715,2.737,2.737,0,0,0,2.759,5.43Z",
  transform: "translate(0)"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Fill_7",
  "data-name": "Fill 7",
  className: "cls-4b",
  d: "M.429.81A2.036,2.036,0,0,0,.823,3.7a2.117,2.117,0,0,0,2.934-.388A2.041,2.041,0,0,0,3.363.422a2.139,2.139,0,0,0-1.551-.4A2.113,2.113,0,0,0,.429.81Z",
  transform: "translate(15.382 23.791)"
})));

var SvgInactiviteBlue = function SvgInactiviteBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.13,
    height: 34.985,
    viewBox: "0 0 26.13 34.985",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInactiviteBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inactivite_blue.608db4d7.svg";
export { ForwardRef as ReactComponent };